import Loadable from 'react-loadable';
import { LoadingIndicator } from 'web-ui-kit/loading';

export default Loadable({
  loader: () => import('./Router' /* webpackChunkName: "Account" */),
  loading: LoadingIndicator
});
